import React from 'react';
import { connect } from 'dva';
import { Row, Col } from 'antd';
import BaseComponent from '../../../components/BaseComponent';

import { Item } from './Library';

class ListPage extends BaseComponent {
  render() {
    const { travel, jpy } = this.props;
    const { items, exRate } = travel;

    return (
      <section className='travel-sale-list'>
        {items &&
          <Row type="flex" gutter={24}>
            {items.map((item, idx) => (
              <Col key={idx} xs={12} sm={8}>
                <Item item={item} jpy={exRate} />
              </Col>
            ))}
          </Row>
        }
      </section>
    );
  }
}

export default connect(({ travel }) => ({
  travel
}))(ListPage);



// WEBPACK FOOTER //
// ./src/pages/travel/components/ListPage.js